import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = '', size = 'md', linkTo = '/', noLink = false, variant = 'horizontal' }) => {
  const sizes = {
    sm: 'h-14',
    md: 'h-20',
    lg: 'h-24',
    xl: 'h-32'
  };

  const variantClasses = {
    horizontal: 'logo-mark--horizontal',
    mark: 'logo-mark--mark'
  };
  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const maskUrl = `url(${publicUrl}/logo/logo.svg)`;
  const alt = variant === 'mark'
    ? 'The Config Team Logo'
    : 'The Config Team — SAP Supply Chain Specialists';

  const element = (
    <span
      role="img"
      aria-label={alt}
      className={`${sizes[size]} logo-mark ${variantClasses[variant] || variantClasses.horizontal}`}
      style={{
        WebkitMaskImage: maskUrl,
        maskImage: maskUrl,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain'
      }}
    />
  );

  if (noLink) {
    return <div className={`flex items-center ${className}`}>{element}</div>;
  }

  return (
    <Link to={linkTo} className={`flex items-center ${className}`}>
      {element}
    </Link>
  );
};

export default Logo;
